import {
  Outlet, useOutletContext, useParams,
} from 'react-router-dom';
import { NotesProvider } from '../contexts/notes';
import { ChecklistProvider } from '../contexts/checklist';
import { RoutingContextType } from '.';

export function ChecklistRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as {id: string};

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <ChecklistProvider id={id}>
      <NotesProvider id={id}>
        <Outlet context={contextValue} />
      </NotesProvider>
    </ChecklistProvider>
  );
}
